<template lang='pug'>
	.container-fluid.p-0.push-wrapper
		.container
			.row
				.col
					.row
						.col-12.my-header.font-weight-bold
							| Статистика ссылок

		.container
			.row
				.col-sm-6




</template>
<script>
import moment from "moment";
import apiDriver from '../../apiDriver';

export default {
	components: {
	},

	data() {
		return {


		};
	},

	computed: {},

	mounted() {

	},

	methods: {

	}
};
</script>
<style scoped lang="stylus">
	div{
		cursor: default;
	}
	.my-header{
		font-size: 26pt;
	}
	.header-pre-push{
		font-size: 1.5rem;
	}
	.header-push{
		font-size: 1.5rem; color: black;
	}


</style>
